<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <v-card>
        <v-toolbar color="secondary" dark>
          <v-toolbar-title>
            <v-icon left>mdi-cart</v-icon>Shops
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn text @click="formOpen = true">
              <v-icon left>mdi-plus</v-icon>Add Shop
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-data-table
          :headers="headers"
          :items="shops"
          :loading="loading"
          :options.sync="pagination" 
          :server-items-length="totalCount"
        >
          <template #[`item.clientType`]="{item}">
            {{item.clientTypeId | uppercase}}
          </template>

          <template #[`item.retailer_percent`]="{item}">
            {{item.retailer_percent ? item.retailer_percent+"%": ''}}
          </template>

          <template #[`item.actions`]="{item}">
            <v-btn icon @click="editItem(item)">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon @click="deleteItem(item)">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
      <list-form
        :item="editedItem"
        :open="formOpen"
        @add="addItem"
        @cancel="cancelItem"
        @update="updateItem"
      ></list-form>
    </div>
  </div>
</template>
<script>
import ListForm from "./_form";
import _ from "lodash";
import { mapActions, mapGetters } from 'vuex';
export default {
  components: {
    ListForm,
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "Name", value: "name", align: "left" },
        { text: "Shop Type", value: "type", align: "left" },
        { text: "Catalog", value: "catalog.name", align: "left" },
        { text: "Retailer percent", value: "retailer_percent", align: "left" },
        { text: "Actions", value:'actions'}
      ],
      pagination: { rowsPerPage: 20 },
      formOpen: false,
      editedItem: null,
      error: 0,
      errorMessage: null,
    };
  },
  filters:{
    uppercase: (v) => v.toUpperCase()
  },
  watch: {
    pagination: {
      handler: _.debounce(function() {
        this.getLists();
      }, 100)
    },
    search: {
      handler: _.debounce(function() {
        this.getLists();
      }, 100)
    }
  },
  computed: {
    ...mapGetters("shops", ["shops", "loading", "totalCount"]),
  },
  mounted: function() {
    this.getLists(); //method1 will execute at pageload
  },
  methods: {
    ...mapActions("shops", {getShops:'index', deleteShop:'delete'}),
    getLists() {
      this.getShops({
        pagination: this.pagination,
        search: this.search
      });
    },
    addItem() {
      this.formOpen = false;
      this.editedItem = null;
      this.getLists();
    },
    updateItem() {
      this.formOpen = false;
      this.editedItem = null;
      this.getLists();
    },
    cancelItem() {
      this.formOpen = false;
      this.editedItem = null;
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.formOpen = true;
    },
    deleteItem(item) {
      confirm("Are you sure you want to delete this item?") && 
      this.deleteShop({
        model: item
      })
      .then(() => {
        this.getLists();
      })
      .catch( ({data}) => {
        this.flashMessage.error({
          message: data.message,
        });
      })
    }
  }
};
</script>
